export default {
  dark: {
    background: 'transparent',
    color: 'white',
    borderColor: 'white',
  },
  white: {
    color: 'white',
  },
  fullWidth: {
    width: '100%',
  },
  buttonGroupFirst: {
    borderBottomRightRadius: 0,
    borderTopRightRadius: 0,
  },
  buttonGroupMiddle: {
    borderRadius: 0,
  },
  buttonGroupLast: {
    borderBottomLeftRadius: 0,
    borderTopLeftRadius: 0,
  },
}
